import { useCallback, useMemo, useRef, useState } from "react";
import { DictType } from "@/model";


export const usePageParam = <T extends DictType>(initialParam: T)  => {
    const [param, setParam] = useState<T>(initialParam);
    const callbackRef = useRef<(() => void) | null>(null);

    const set = useCallback((newParam: Partial<T>) => {
        if (!param) {
            if (newParam) {
                setParam(newParam as T);
            }
            return;
        }
        const isConditionChanged =
            Object.entries(newParam)
                .filter(([key]) => key !== 'page')
                .some(([key, value]) => param[key] !== value);

        if (isConditionChanged) {
            setParam({ ...param, ...newParam, page: 0 });
        } else {
            setParam({ ...param, ...newParam });
        }
        callbackRef.current?.();
    }, [param, setParam]);

    const updateCallback = useCallback((callback: () => void) => {
        callbackRef.current = callback;
    }, []);

    const reset = useCallback(() => {
        setParam(initialParam);
    }, [setParam, initialParam]);

    return useMemo(() => {
        return {
            param,
            set,
            reset,
            updateCallback
        };
    }, [param, set, reset, updateCallback]);
};
